module.exports = __webpack_public_path__ + "static/media/Livre7.25f1c663.png";